/**
 * Concept Archetype
 * 
 * @author Daniel Lepe
 * @date 25 de Sept, 2023
 * @version 1.0
 */

import _ from 'lodash'

const baseController = 'cedesgroups'

const baseIndex = baseController + '/index'


const archetype = [
    {
        key: 'id',
        type: 'hidden'
    },
    [{
        key: 'lunch_cedes_id',
        label: 'Escuela/Empresa',
        type: 'select',
        options: []
    }],
    [{
        key: 'grupo_clase',
        // type: 'textarea'
    },{
        key: 'grupo_titulo',
        // type: 'textarea'
    }],
    [{
        key: 'position',
        label: 'Posición',
        type: 'select',
        default: 1,
        options: (()=>{
            let arr = []
            for (let index = 1; index < 15; index++) arr.push(index);
            return arr
        })()
    }],
];

const captions = [
    {key: 'position', label: '#'},
    {key: 'grupo'},
    {key: '_'},
]

let automodalHandler = (conceptId) => {
    let str = baseController + '/' + 'define' + ((_.isNil(conceptId)) ? '' : ('/' + conceptId));
    // console.log("isNil", _.isNil(conceptId))
    return str;
}

let GroupsFromSedesIDURI = (sedesId) => {
    let str = baseController + '/bysede/' + sedesId;
    return str;
}


export {
    archetype,
    captions,
    baseIndex,
    automodalHandler,
    GroupsFromSedesIDURI
}